import { combineReducers } from 'redux';
import * as auth from './ducks/auth.duck';
//import { reducer as users } from './ducks/users.duck';
import { reducer as loader } from './ducks/loader.duck';
//import { reducer as access } from './ducks/access.duck';
import { reducer as collegiate_body } from './ducks/collegiateBody.duck';
import { reducer as organos } from './ducks/selectedCollegiateBody';
import { reducer as menu } from './ducks/menu';
import { reducer as changePassword } from './ducks/changePassword';
import { reducer as passwordRequest } from './ducks/passwordRequest';
import { reducer as organsByRol } from './ducks/organsByRole';
import { reducer as appParams } from './ducks/appParams';
export const rootReducer = combineReducers({
	auth: auth.reducer,
	//users,
	loader,
	//access,
	collegiate_body,
	organos,
	menu,
	changePassword,
	organsByRol,
	passwordRequest,
	appParams,
});
